<template>
  <div id="app" v-if="showContent">
    <XHeader v-if="!hideHeader" />
    <div class="container">
      <router-view />
    </div>
    <GoService />
    <CookiePolicy />
    <XFooter v-if="!hideFooter" />
  </div>
</template>

<script>
import XHeader from "./components/Header";
import XFooter from "./components/Footer";
import GoService from "./components/GoService";
import CookiePolicy from "./components/CookiePolicy.vue";
import types from "@/store/types";
import api from "@/utils/api";

export default {
  components: { XHeader, XFooter, GoService, CookiePolicy },
  computed: {
    showContent() {
      return this.$route.name && !["Home"].includes(this.$route.name);
    },
    tagsConfig() {
      return this.$store.state.tagsConfig;
    },
    brandPathSegment() {
      const pathname = location.pathname.split('?')[0].split('#')[0]; // 去除查询参数和锚点
      const brandIndex = pathname.indexOf('/brand/');
      if (brandIndex === -1) return '';

      // 提取 /brand/ 后面的所有内容
      const afterBrand = pathname.substring(brandIndex + 7); // 7 是 "/brand/".length
      return afterBrand;
    },
    hideHeader() {
      const hidePaths = ["yellow-collection", "yellow-collection/store"];
      return hidePaths.includes(this.brandPathSegment);
    },

    hideFooter() {
      const hidePaths = ["yellow-collection", "yellow-collection/store"];
      return hidePaths.includes(this.brandPathSegment) || location.pathname.includes('italian-made');
    }


  },
  created() {
    this.$store.dispatch(types.GET_OSS_COMMON_CONFIG);
    this.$store.dispatch(types.GET_OSS_TAGS);
  },
  methods: {
    getUserState() {
      this.$store.dispatch("setIsShowCustomerTag", false);
      // 后端已校验
      const excludeRoutes = ["Checkout", "Orderdetail"];
      const customerType = this.tagsConfig?.customer_type;
      if (customerType === "all_customer") {
        this.$store.dispatch("setIsShowCustomerTag", true);
      } else if (customerType === "new_customer") {
        try {
          const hasIntersection = excludeRoutes.some((route) =>
            this.tagsConfig.show_page.includes(route)
          );

          if (excludeRoutes.includes(this.$route.name) && hasIntersection) {
            this.$store.dispatch("setIsShowCustomerTag", true);
            return;
          }

          const validPaths =
            process.env.VUE_APP_ENV === "uat"
              ? ["/cn/zh-cn/shop", "/cn/zh-cn/shop/", "/cn/zh-cn/?"]
              : ["/cn/zh-cn", "/cn/zh-cn/", "/cn/zh-cn/?"];
          const isHome = validPaths.includes(location.pathname);
          const cmsPage = location.pathname.includes("cn/zh-cn/landingpage");


          if (this.tagsConfig.show_page.includes(this.$route.name) || isHome || cmsPage) {
            api[types.CHECK_NEW_CUSTOMER_STATUS]()
              .then((res) => {
                const { code, data } = res;
                if (code === 1) {
                  this.$store.dispatch(
                    "setIsShowCustomerTag",
                    data?.is_new_customer
                  );
                } else {
                  this.$store.dispatch("setIsShowCustomerTag", false);
                }
              })
              .catch(() => {
                this.$store.dispatch("setIsShowCustomerTag", false);
              });
          }
        } catch (error) {
          this.$store.dispatch("setIsShowCustomerTag", false);
          console.error("Error fetching commonConfig:", error);
        }
      }
    },
    setStyles(config) {
      const root = document.documentElement;
      if (config) {
        config.color && root.style.setProperty("--tag-color", config.color);
        config.backgroundColor &&
          root.style.setProperty(
            "--tag-background-color",
            config.backgroundColor
          );
        config.borderColor &&
          root.style.setProperty("--tag-border-color", config.borderColor);
      }
    },
    updateGlobalTag(config) {
      this.getUserState();
      this.setStyles(config);
    },
  },

  watch: {
    tagsConfig: {
      handler(newVal) {
        this.updateGlobalTag(newVal);
      },
      immediate: true,
    },
    $route() {
      // 配置异步到达由 tagsConfig watcher 覆盖, 路由切换只需立即刷新一次
      this.getUserState();
    },
  },
};
</script>

<style lang="scss">
@import "../src/assets/scss/reset.scss";
@import "../src/assets/common.css";

body.el-loading-parent--hidden {
  overflow-y: auto !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

#app {
  font-family: 'MatterSQ', 'NotoSansCJKsc', 'FZLanTingHeiS-R-GB', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// 联蔚iconfont
@font-face {
  font-family: 'iconfont';
  /* project id 1684665 */
  src: url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.eot');
  src: url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.eot?#iefix') format('embedded-opentype'),
    url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.woff') format('woff'),
    url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_1684665_m819w7ih1xa.svg#iconfont') format('svg');
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
// @font-face {
//   font-family: 'iconfont-ot-website';  /* Project id 4520746 */
//   src: url('//at.alicdn.com/t/c/font_4520746_lozla6bptrm.woff2?t=1714483338333') format('woff2'),
//        url('//at.alicdn.com/t/c/font_4520746_lozla6bptrm.woff?t=1714483338333') format('woff'),
//        url('//at.alicdn.com/t/c/font_4520746_lozla6bptrm.ttf?t=1714483338333') format('truetype');
// }

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "iconfont-ot-website"; /* Project id 4333164 */
  src: url('//at.alicdn.com/t/c/font_4333164_chg2e7osemm.woff2?t=1782113819571') format('woff2'),
       url('//at.alicdn.com/t/c/font_4333164_chg2e7osemm.woff?t=1782113819571') format('woff'),
       url('//at.alicdn.com/t/c/font_4333164_chg2e7osemm.ttf?t=1782113819571') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconfont-ot-website {
  font-family: "iconfont-ot-website";
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 0 10px;
  margin: 0 auto;
}

.breadcrumb {
  font-size: 0.6875rem;
  top: 0;
  left: 50%;
  z-index: 1;
  line-height: 1em;
  padding: 0.5em 0;
  width: 100%;
  margin: 0;
  text-align: left;
}

.el-message {
  min-width: 320px;
}

.el-message-box {
  width: 300px;
  max-width: 100%;
}

.el-button.el-button--default:hover {
  color: #606266;
  border-color: #CCC;
  background-color: #FFF;
}

.el-button.el-button--primary {
  color: #FFF;
  background-color: #7f0019;
  border-color: #7f0019;
}

.el-button.el-button--primary:hover {
  color: #FFF;
  border-color: #7f0019;
  background-color: #7f0019;
}

.el-icon-close {
  color: #909399 !important;
}

.__vuescroll.hasVBar .__panel .__view {
  padding-right: 10px;
}

.__vuescroll .__rail-is-vertical .__bar-wrap-is-vertical .__bar-is-vertical {
  background-color: #dfdfdf !important;
}

.custom-tags {
  color: var(--tag-color, #212322) !important;
  background-color: var(--tag-background-color, none) !important;
  border: 1px solid var(--tag-border-color, #212322) !important;
}
</style>
